import { useParams } from "react-router-dom";
import { useMemo, useCallback } from "react";
import { useGetTagSpectraQuery } from "../tagsSlice";

const useTagSpectraBlock = () => {
  const { tagId } = useParams();
  const { data: spectraData } = useGetTagSpectraQuery(
    { tagId },
    { skip: tagId == null }
  );

  const spectraIds = useMemo(
    () => spectraData?.map((spectrum) => spectrum?.id) ?? [],
    [spectraData]
  );
  const link = useCallback((rowData) => `/spectra/${rowData}`, []);

  const items = useMemo(
    () => [
      {
        id: "spectraArray",
        type: "spectraArray",
        data: spectraIds,
        link,
      },
      { id: "notes", formOnly: true },
    ],
    [spectraIds, link]
  );

  return items;
};

export default useTagSpectraBlock;
